import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

import {
  createApplicationHistoryRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';
import { applicationHistoryKey } from '@features/applications';

type createApplicationHistoryProps = {
  applicationId?: number | null;
  type: string
  enabled?: boolean;
};

export const createApplicationHistory = ({
  applicationId,
  type,
  enabled,
}: createApplicationHistoryProps) => {
  const { data: createApplicationHistoryData } = useQuery({
    queryKey: [applicationHistoryKey, applicationId],
    queryFn: () => {
      return axiosInstance
        .get(`${createApplicationHistoryRoute}?application_id=${applicationId}&type=${type}`)
        .then((res) => res.data);
    },
    enabled: Boolean(applicationId && enabled),
  });
  return {
    createApplicationHistoryData,
  };
};

